import { AuthAPI } from "@api/Auth.api";
import ButtonVariants from "@core-components/button/ButtonVariants";
import GradientBorder from "@core-components/gradient-border/GradientBorder";
import Icon from "@core-components/icon/Icon";
import { useDisclosure } from "@mantine/hooks";

const DiscordAuthButton = () => {
  const [loading, { open: startLoading, close: stopLoading }] =
    useDisclosure(false);

  const askForAuthorization = () => {
    startLoading();
    AuthAPI.authorizeDiscord()
      .then((url) => {
        document.location.href = url;
      })
      .finally(() => setTimeout(stopLoading, 500));
  };

  return (
    <GradientBorder
      className="gradient-gray-to-light-white hover-scale w-fit rounded-xl"
      childrenClassName="!bg-primary-default"
    >
      <ButtonVariants.ActionIcon
        className="hover:bg-[#5562ea]"
        onClick={askForAuthorization}
        loading={loading}
      >
        <Icon.Discord />
      </ButtonVariants.ActionIcon>
    </GradientBorder>
  );
};

export default DiscordAuthButton;
